import { Page } from '@app/components/page/Page';
import { ListViewLocal } from '@app/core/list-view/ListViewLocal';
import { useStations } from '@app/core/stations/hooks/useStations';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { UploadDto } from '@app/modules/social-export/social-export.types';
import { socialExportListUploadStatusesByPlatform } from '@mi-front/api-v2';
import { useMemo } from 'react';
import { createSocialUploadedFiltersConfig } from './filters/social-uploaded-filters-config';
import { PlatformUploadedTable } from './PlatformUploadedTable';

type Props = {
  platform: SocialPlatform;
};

/**
 * ListViewLocal orchestrator for uploads of one social platform (local station/status filters).
 */
export function PlatformUploaded({ platform }: Props) {
  const stations = useStations();
  const filters = useMemo(() => createSocialUploadedFiltersConfig(stations), [stations]);

  const queryFn = async (): Promise<UploadDto[]> => {
    const response = await socialExportListUploadStatusesByPlatform(platform.id);
    return response.results;
  };

  return (
    <ListViewLocal
      listId={`admin-social-uploaded-${platform.id}`}
      filters={filters}
      queryFn={queryFn}
      ListComponent={PlatformUploadedTable}
      ListWrapper={Page.Content}
      enablePagination={false}
      showProgress
    />
  );
}
